import { Button } from "primereact/button";
import { useForm } from "react-hook-form";
import { Accordion, AccordionTab } from "primereact/accordion";
import { JVDate } from "../../shared/JVDate";
import { startOfMonth, endOfMonth, startOfWeek, endOfWeek, startOfQuarter, endOfQuarter } from "date-fns";
import { useEffect, useState } from "react";
import { Dropdown } from "primereact/dropdown";
import { JVDropdown } from "../../shared/JVDropdown";
import { IDropdown } from "../../models/BaseModel";
import { Fetch } from "../../shared/Fetch";
import { JVMultiselect } from "../../shared/JVMultiselect";

export interface IFilter {
    fromDate?: Date;
    toDate?: Date;
    range?: string;
    assigned_To?: number[];
}

interface Iprops {
    filter: IFilter;
    loading: boolean;
    header: any;
    setFilter: (filter: IFilter) => void;
}

export const Filter = (props: Iprops) => {
    const [users, setUsers] = useState<IDropdown[]>();

    const { control, handleSubmit, reset, watch, trigger, setValue } = useForm<IFilter>({
        defaultValues: props.filter
    });

    useEffect(() => {
        loadUsers();

    }, []);

    const loadUsers = async () => {
        const response = await Fetch("user/dropdown", "GET", null, null, null);
        if (response) {
            const userList = await response.json();
            setUsers([...userList]);
        }
    }


    const fromDate = watch("fromDate");
    const toDate = watch("toDate");
    const range = watch("range");

    useEffect(() => {
        if (range) {
            let start: Date | undefined;
            let end: Date | undefined;
            const now = new Date();

            switch (range) {
                case "this-week":
                    start = startOfWeek(now);
                    end = endOfWeek(now);
                    break;
                case "this-month":
                    start = startOfMonth(now);
                    end = endOfMonth(now);
                    break;
                case "quarterly":
                    start = startOfQuarter(now);
                    end = endOfQuarter(now);
                    break;
            }

            if (start && end) {
                reset({ ...watch(), fromDate: start, toDate: end, range: range });
            }
        }
    }, [range, reset]);

    useEffect(() => {
        if (fromDate || toDate) {
            trigger(["fromDate", "toDate"]);
        }
    }, [fromDate, toDate, trigger]);

    const onSubmit = (data: IFilter) => {
        props.setFilter(data);
    };

    const clear = () => {
        const today = new Date();
        const resetData: IFilter = {
            fromDate: startOfMonth(new Date()),
            toDate: endOfMonth(new Date()),

            range: undefined,
            assigned_To: []
        };
        reset(resetData);
        // props.setFilter(resetData);
    };
    return (
        <Accordion>
            <AccordionTab header={props.header}>

                <form onSubmit={handleSubmit(onSubmit)} className="p-fluid grid formgrid">

                    <div className="field col-12 md:col-3">
                        <label htmlFor="range">Quick Select</label>
                        <Dropdown
                            id="range"
                            value={range}
                            options={[
                                { label: "This Week", value: "this-week" },
                                { label: "This Month", value: "this-month" },
                                { label: "Quarterly", value: "quarterly" }
                            ]}
                            onChange={(e) => reset({ ...watch(), range: e.value })}
                            placeholder="Select Range"
                            showClear
                        />
                    </div>

                    <JVDate
                        column={3}
                        label="From Date"
                        control={control}
                        name="fromDate"
                        required={!!toDate}
                        maxDate={new Date()}
                    />

                    <JVDate
                        column={3}
                        label="To Date"
                        control={control}
                        name="toDate"
                        maxDate={new Date()}
                        required={!!fromDate}
                    />

                    <JVMultiselect
                        column={3}
                        filter
                        label="Assign To"
                        options={users}
                        optionLabel="name"
                        optionValue="id"
                        value={watch("assigned_To") || []}
                        placeholder="Select Users"
                        onChange={(ids: number[]) => {
                            setValue("assigned_To", ids);
                        }}
                    />

                    <div className="col-12 flex justify-content-end gap-2 mt-3">
                        <Button
                            label="Search"
                            type="submit"
                            loading={props.loading}
                            className="p-button-sm p-button-rounded"
                        />

                        <Button
                            label="Clear"
                            type="button"
                            onClick={clear}
                            className="p-button-sm p-button-rounded p-button-outlined"
                        />
                    </div>

                </form>
            </AccordionTab>
        </Accordion>
    );
};